<template>
  <nav class="navbar navbar-expand-lg ">
    <div class="container-fluid">
      <div class="navbar-minimize">
        <button class="btn btn-outline btn-fill btn-round btn-icon d-none d-lg-block" @click="minimizeSidebar">
          <i :class="$sidebar.isMinimized ? 'fa fa-ellipsis-v' : 'fa fa-navicon'"></i>
        </button>
      </div>
      <a class="navbar-brand">{{this.$route.name}}</a>
      <button type="button"
              class="navbar-toggler navbar-toggler-right"
              :class="{toggled: $sidebar.showSidebar}"
              aria-expanded="false"
              @click="toggleSidebar">
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end">
        <ul class="navbar-nav">
          <drop-down position="right">
            <i slot="title" class="nc-icon nc-bullet-list-67"></i>
            <a @click.prevent="lock" class="dropdown-item" href="#">
              <i class="nc-icon nc-lock-circle-open"></i> Bloquear
            </a>
            <a @click.prevent="signout" class="dropdown-item text-danger pointer">
              <i class="nc-icon nc-button-power"></i> Cerrar Sesión
            </a>
          </drop-down>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
  import { mapActions } from 'vuex'

  export default {
    computed: {
      routeName () {
        const {name} = this.$route
        return this.capitalizeFirstLetter(name)
      }
    },
    data () {
      return {
        activeNotifications: false
      }
    },
    methods: {
      // mapeamos las acciones de nuestro store para poder llamarlas desde este script
      ...mapActions({
        logout: 'auth/logout',
        cleanUserlogout: 'auth/cleanUserlogout',
        inactiveUser: 'auth/inactiveUser',
      }),

      // llamamos a nuestra accion para limpiar el token, luego limpiamos el usuario
      signout () {
        this.$emit('dashLoading', true)
        this.logout().then(() => {
          this.$router.push('/login')
          this.cleanUserlogout()
        })
      },
      lock(){
        this.$emit('dashLoading', true)
        let data = {
            user: this.$store.state.auth.user.username,
            name: this.$store.state.auth.user.first_name+' '+this.$store.state.auth.user.last_name,
            avatar: this.$store.state.auth.user.avatar,
            active: 0
        }
        localStorage.setItem( 'user', JSON.stringify(data) )
        this.$router.push('/lock')
        localStorage.removeItem('token')
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      minimizeSidebar () {
        this.$sidebar.toggleMinimize()
      }
    }
  }
</script>
